import { render, staticRenderFns } from "./BatchShipment.vue?vue&type=template&id=52963544&"
import script from "./BatchShipment.vue?vue&type=script&lang=js&"
export * from "./BatchShipment.vue?vue&type=script&lang=js&"
import style0 from "./BatchShipment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports